import './styles/_slider-component.scss';
import {
  markScriptFullyLoaded,
  onDocumentReady,
  isScriptFullyLoaded,
} from '../utils/dom';
import { debounce } from '../utils/performance';
import Swiper from 'swiper-latest/bundle';
import 'swiper/swiper-bundle.css';

let userComeAcrossWithSection = false;

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.01,
};

const state = {
  variables: {
    title: 'slider',
  },
  elements: {},
  loadedCollections: {},
  components: [],
};

const cacheState = () => {
  state.elements = {
    sliders: document.querySelectorAll('[data-swiper-id]'),
  };
  const sections = Array.from(document.querySelectorAll('.slider'));
  state.components = sections.reduce((acc, curr) => {
    const currentComponent = {
      swiperEl: curr.querySelector('.swiper[data-swiper-id]'),
      totalSlides: Array.from(
        curr.querySelectorAll('.swiper-slide.slider__item')
      ).length,
      banners: Array.from(curr.querySelectorAll('.slider__item')),
    };
    return [...acc, currentComponent];
  }, []);
};

function setVideoBackground() {
  const isMobile = window.matchMedia('(max-width: 600px)').matches;
  state.components.forEach((component) => {
    const { banners } = component;
    banners.forEach((banner) => {
      const video = banner.querySelector('video');
      if (!video) return;

      const currentSrc = video.src;
      const newSrc = isMobile
        ? video.dataset.srcMobile
        : video.dataset.srcDesktop;
      if (currentSrc === newSrc) return;
      video.src = newSrc;
    });
  });
}

function initVideo() {
  state.components?.forEach((component) => {
    const { banners } = component;

    banners?.forEach((banner) => {
      const videoEl = banner.querySelector('video');
      if (!videoEl) return;

      let wasPlaying = true;
      let wasMuted = true;
      const playPauseBtn = banner.querySelector('[data-type="video"]');
      const muteUnmuteBtn = banner.querySelector('[data-type="audio"]');

      playPauseBtn.addEventListener('click', () => {
        if (playPauseBtn.dataset.state === 'playing') {
          videoEl.pause();
          playPauseBtn.dataset.state = 'paused';
        } else {
          videoEl.play();
          playPauseBtn.dataset.state = 'playing';
        }
      });

      muteUnmuteBtn.addEventListener('click', () => {
        if (muteUnmuteBtn.dataset.state === 'muted') {
          videoEl.muted = false;
          muteUnmuteBtn.dataset.state = 'unmuted';
        } else {
          videoEl.muted = true;
          muteUnmuteBtn.dataset.state = 'muted';
        }
      });

      document.addEventListener('swiper:slide:changed', () => {
        if (playPauseBtn.dataset.state === 'playing') {
          videoEl.pause();
          playPauseBtn.dataset.state = 'paused';
        } else if (
          videoEl.closest('.slider__item').classList.contains('active')
        ) {
          videoEl.play();
          playPauseBtn.dataset.state = 'playing';
        }
      });

      const observer = new IntersectionObserver((e) => {
        if (!e[0].isIntersecting) {
          if (userComeAcrossWithSection) {
            wasPlaying = !videoEl.paused;
          }
          wasMuted = videoEl.muted;

          videoEl.pause();
          playPauseBtn.dataset.state = 'paused';
          return;
        }

        videoEl.muted = wasMuted;
        userComeAcrossWithSection = true;
        if (!wasPlaying) return;

        videoEl.play();
        playPauseBtn.dataset.state = 'playing';
      }, options);
      observer.observe(videoEl);
    });
  });
}

function initSwipers() {
  state.elements.sliders?.forEach((swiperContainer) => {
    const prevBtn = swiperContainer.querySelector('.swiper-button-prev');
    const nextBtn = swiperContainer.querySelector('.swiper-button-next');
    const slidesPerView = swiperContainer.getAttribute('data-per-view') || 1;
    const swiper = new Swiper(swiperContainer, {
      preloadImages: false,
      loop: false,
      slidesPerView: 1,
      lazy: true,
      speed: 500,
      breakpoints: {
        800: {
          slidesPerView: slidesPerView,
        },
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
    prevBtn.classList.remove('hidden');
    nextBtn.classList.remove('hidden');
  });
};

const attachEventListeners = () => {
  const debouncedSetVideoBackground = debounce(setVideoBackground, 200);
  window.addEventListener('resize', debouncedSetVideoBackground);
};

function init() {
  const isLoadedBefore = isScriptFullyLoaded(state.variables.title);
  if (isLoadedBefore) return;
  markScriptFullyLoaded(state.variables.title);

  cacheState();
  attachEventListeners();
  initSwipers();
  setVideoBackground();
  initVideo();
};

onDocumentReady(init);
